<ng-container *ngFor="let item of items">
    <div class="col-12 px-10" 
        [ngClass]="item?.alignment" 
        [style.padding-top.px]="item?.padding"
        [style.padding-bottom.px]="item?.padding" 
        *ngIf="item?.type == 'HEADING'" 
        [innerHTML]="item?.content">
    </div>

    <div class="col-12 px-10">
        <div class="d-block mx-auto" style="max-width: 700px;"
            [ngClass]="item?.alignment" 
            [style.padding-top.px]="item?.padding"
            [style.padding-bottom.px]="item?.padding" 
            *ngIf="item?.type == 'TEXTAREA'" 
        >
            <p class="font-size-16">{{ item?.content }}</p>
        </div>
    </div>
</ng-container>
<div *ngIf="images.length > 0">
    <div class="col-12 responsive-partial-overflow-swiper">
        <swiper [config]="responsivePartialOverflowConfig"
            (swiper)="onSwiper($event)"
            (slideChange)="onSlideChange()"
            class="w-100"
        >     
            <ng-template swiperSlide *ngFor="let image of images">
                <div class="card shadow-xs mb-4 image-card w-100 h-100 cursor-pointer">
                    <div class="card-body" [ngStyle]="{'background-image':'url(' + image?.content + ')'}">
                    </div>
                </div>
            </ng-template>
        </swiper>
        <div class="swiper-buttons text-right d-none d-sm-none d-md-block">
            <button class="btn btn-white shadow-xs rounded-circle btn-previous" 
                    [class.disabled]="isBegin" 
                    (click)="gotoPrevious()"
            >
                <mat-icon aria-hidden="false" aria-label="Previous">arrow_back</mat-icon>
            </button>
            <button class="btn btn-white shadow-xs rounded-circle btn-next" 
                    [class.disabled]="isEnd"
                    (click)="gotoNext()"
            >
                <mat-icon aria-hidden="false" aria-label="Next">arrow_forward</mat-icon>
            </button>
        </div>
    </div>
</div>
